export class MissingAuthHeaderError extends Error {
  static name = 'MissingAuthHeaderError'
  name = 'MissingAuthHeaderError'
}

export class InvalidSignatureError extends Error {
  static name = 'InvalidSignatureError'
  name = 'InvalidSignatureError'
}

export class InvalidPeerError extends Error {
  static name = 'InvalidPeerError'
  name = 'InvalidPeerError'
}

export class BadResponseError extends Error {
  static name = 'BadResponseError'
  name = 'BadResponseError'
}

export class NotAuthenticatedError extends Error {
  static name = 'NotAuthenticatedError'
  name = 'NotAuthenticatedError'
}

export class InvalidStateError extends Error {
  static name = 'InvalidStateError'
  name = 'InvalidStateError'
}
